package com.ballisticapps.DreamJournalAIWebsite.pages

import androidx.compose.runtime.*
import com.ballisticapps.DreamJournalAIWebsite.sections.MainSection
import com.varabyte.kobweb.core.Page

@Page
@Composable
fun HomePage() {
    MainSection()
}


